import Config from '../../../../config/Config'
import { mergeMap, map, catchError, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { ofType } from 'redux-observable'
import queryString from '@promoboxx/query-string-babel'
import { headersSelector } from '../../../auth/selectors'
import * as actions from './actions'

const buildSearchCampaignsParams = (payload) => {
  const {
    perPage,
    offset = 0,
    search,
    sortColumn,
    sortDirection,
    filters,
    tags,
    fields,
  } = payload
  let params = queryString.stringify(
    {
      per_page: perPage,
      offset,
      search,
      sort_column: sortColumn,
      sort_direction: sortDirection,
      filters: JSON.stringify(filters),
      tags,
      fields,
    },
    { arrayFormat: 'bracket' },
  )
  if (params) {
    params = `?${params}`
  }
  return params
}

/**
 * @typedef SearchCampaignsByRetailerAccountPayload
 * @property {number} retailerAccountId
 * @property {string} [search] - search term
 * @property {number} [perPage] - number of results per page
 * @property {number} [offset] - starting offset
 * @property {string} [sortColumn] - column to sort on
 * @property {string} [sortDirection] - asc or desc
 * @property {object} [filters] - (facebook, twitter, instagram, embed, email, asset): include results that have these when true
 *    (popular, opt_out): can be true or false, (show_state): one of all, new, active, expired
 * @property {array} [tags] - an array of tags dynamically created from campaigns
 * @property {array} [fields] - additional fields to include
 * @link http://api.promoboxx.com/docs/V2/campaigns/search.html
 */
const searchCampaignsByRetailerAccountObservable = ([action, state]) => {
  const headers = headersSelector(state)
  const { retailerAccountId } = action.payload

  if (!headers) {
    throw new Error('Bad or Non-existent auth headers')
  }

  if (!retailerAccountId) {
    throw new Error('payload.retailerAccountId is required')
  }

  const params = buildSearchCampaignsParams(action.payload)

  const settings = {
    method: 'GET',
    responseType: 'json',
    headers,
    url: `${Config.API_BASE}/v2/retailer_accounts/${retailerAccountId}/campaigns/search${params}`,
  }

  return ajax(settings).pipe(
    map((payload) => {
      const requestDate = new Date()
      return {
        type: actions.SEARCH_CAMPAIGNS_BY_RETAILER_ACCOUNT_FULFILLED,
        payload: {
          response: payload.response,
          filters: action.payload,
          total: parseInt(payload.xhr.getResponseHeader('x-total')),
          requestDate: requestDate.toISOString(),
        },
      }
    }),
    catchError((payload) => {
      const requestDate = new Date()
      return of({
        type: actions.SEARCH_CAMPAIGNS_BY_RETAILER_ACCOUNT_REJECTED,
        payload: {
          response: payload.response,
          filters: action.payload,
          requestDate: requestDate.toISOString(),
        },
      })
    }),
  )
}

const searchCampaignsByRetailerAccountEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.SEARCH_CAMPAIGNS_BY_RETAILER_ACCOUNT),
    withLatestFrom(state$),
    mergeMap(searchCampaignsByRetailerAccountObservable),
    catchError((payload) => {
      return of({
        type: actions.SEARCH_CAMPAIGNS_BY_RETAILER_ACCOUNT_REJECTED,
        payload,
      })
    }),
  )
}

export const observables = {
  searchCampaignsByRetailerAccountObservable,
}

export default {
  searchCampaignsByRetailerAccountEpic,
}
